import React,{Component} from 'react';
import {NavBar, Toast} from 'antd-mobile';
import {salesInfo} from "../../../service/memberService";
import './style.less'
import connect from "react-redux/es/connect/connect";
const ddicon = require('../../../common/image/ddicon.png');
const flicon = require('../../../common/image/flicon.png');
@connect(
    state => ({userInfo: state.userInfo})
)
export default class Promote extends Component{
    constructor(props) {
        super(props);
        this.state={
            info:{}
        }
    }
    componentDidMount() {
        let params = {
            source: 1,
            token:this.props.userInfo.token,
        };
        salesInfo(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setState({info:res.data.data});
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }

    render(){
        return(
            <div className="promoteScreen">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />}
                >用户推广</NavBar>
                <div className="warp">
                    <div className="content">
                        <div className="title">
                            <span className="phone">{this.state.info.phone}</span>
                            <span className="type fullTime">{this.state.info.businessType == 1 ? "兼职分销员" : "全职分销员"}</span>
                        </div>
                        <div className="number">
                            <div className="rebate">累计返利 <span>{this.state.info.amountCount}</span> 元</div>
                            <div className="btn"><button onClick={()=>this.props.history.push('/rebate')}>查看明细</button></div>
                        </div>
                        <div className="cumulativeBox">
                            <div className="left">
                                <div className="box">
                                    <div className="cumulative">
                                        <p>{this.state.info.userCount}</p>
                                        <span>累计邀请用户</span>
                                    </div>
                                    <div className="cumulative">
                                        <p>{this.state.info.orderCount}</p>
                                        <span>累计完成订单</span>
                                    </div>
                                </div>
                                <button onClick={()=>this.props.history.push('/endOrder')}>查看明细</button>
                            </div>
                            <div className="border"></div>
                            <div className="right">
                                <div className="cumulative">
                                    <p>{this.state.info.walletCount}</p>
                                    <span>累计邀请开通钱包数量</span>
                                </div>
                                <button onClick={()=>this.props.history.push('/walletInfo')}>查看明细</button>
                            </div>
                        </div>
                        {/*<div className="infoBtn">
                            <div className="info" onClick={()=>this.props.history.push('/rebate')}>
                                <img src={ddicon} alt=""/>
                                <span>返利明细</span>
                            </div>
                            <div className="endOrder" onClick={()=>this.props.history.push('/endOrder')}>
                                <img src={flicon} alt=""/>
                                <span>完成订单</span>
                            </div>
                        </div>*/}
                        <div className="ewmBox">
                            <p>——  推广二维码  ——</p>
                            <div className="text">用户扫描下方二维码进行注册</div>
                            <img src={this.state.info.qrUrl} alt=""/>
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Promote/index.js